module.exports = __webpack_public_path__ + "img/Christie.d3de9fff.png";